import React, { useEffect, useState } from "react";
import { setBreadcrumbItems } from "../../store/actions";
import { connect } from "react-redux";
import Spinners from "components/Common/Spinner";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import * as url from "../../helpers/url_helper";
import { toast } from "react-toastify";

const Notification = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Notification List", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("Notification", breadcrumbItems);
  });
  useEffect(() => {
    onGetNotificationList();
  }, []);
  async function NotificationDelete(id) {
    setLoading(true);
    if (!id) {
      return toast.error("Id not found");
    }
    if (window.confirm("Are you sure delete this notification")) {
      let urlPath = "notification/delete-notification";

      fetch(url.VUF_APP_API + urlPath, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          notification_id: id,
        }),
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          if (responseData.message) {
            toast.success("Notification Deleted Successfully");
          }
        })
        .finally((final) => {
          setLoading(false);
        });
    }
  }
  async function onGetNotificationList() {
    let urlPath = "notification/notification";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          const result = responseData.result;
          const notificationList = [];
          result.map((notify) => {
            const image = notify.bannerImage;
            const fileName = image.split("/")[2];
            notificationList.push({
              id: notify._id,
              title: notify.title,
              description: notify.description,
              bannerImage: fileName !== undefined ? image : "---",
            });
          });
          setNotificationList(notificationList);
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  const formattedNotificationList = notificationList.map((notification) => ({
    ...notification,
    bannerImages: [
      notification.bannerImage && (
        <img
          key={notification.bannerImage}
          src={`${url.VUF_APP_BANNER_URL}${notification.bannerImage}`}
          alt="Banner"
          style={{ maxWidth: "30%", height: "auto" }}
        />
      ),
    ],
    Action: [
      <button
        type="button"
        onClick={(e) => NotificationDelete(notification.id)}
        className="btn btn-danger btn-sm  m-1"
      >
        <span
          className=" menu-icon fas fa fa-trash"
          style={{ color: "white" }}
        ></span>
      </button>,
    ],
  }));
  const tableData = {
    columns: [
      {
        label: "Title",
        field: "title",
        sort: "asc",
        width: 23,
      },
      {
        label: "Description",
        field: "description",
        sort: "asc",
        width: 23,
      },
      {
        label: "Action",
        width: 18,
        sort: "asc",
        field: "Action",
      },
    ],
    rows: formattedNotificationList,
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <>
          <Row>
            <Col xl="12">
              <Card>
                <CardHeader>
                  <div className="row align-items-center">
                    <div className="col d-flex justify-content-between align-items-center">
                      <CardTitle className="h4 mb-0">
                        Notification List
                      </CardTitle>
                      <Link to="/Add" className="btn btn-primary h5 mb-0">
                        <span className="menu-text text-white">
                          <i className="fa fa-plus me-2"></i>
                          Add Notification
                        </span>
                      </Link>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <br />
                  <div class="row">
                    <MDBDataTable
                      responsive
                      striped
                      bordered
                      data={tableData}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(Notification);
